var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _c(
        "el-form",
        {
          staticClass: "bill-form-content",
          attrs: {
            "label-position": "left",
            "label-width": "85px",
            model: _vm.billing
          }
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 5, type: "flex" } },
            [
              _c(
                "el-col",
                { staticStyle: { width: "630px" }, attrs: { span: 8 } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "section",
                      staticStyle: { flex: "1", height: "100%" }
                    },
                    [
                      _c(
                        "el-col",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("CargoMsg.Cargo_BillNo") }
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: true, no: "1" },
                                model: {
                                  value: _vm.billing.billingNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.billing, "billingNo", $$v)
                                  },
                                  expression: "billing.billingNo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_SettleAccountsTo")
                              }
                            },
                            [
                              !_vm.isBySettlementAgent
                                ? _c("el-input", {
                                    attrs: { disabled: true, no: "2" },
                                    model: {
                                      value: _vm.billing.settlement,
                                      callback: function($$v) {
                                        _vm.$set(_vm.billing, "settlement", $$v)
                                      },
                                      expression: "billing.settlement"
                                    }
                                  })
                                : _vm._e(),
                              _vm.isBySettlementAgent
                                ? _c("cargo-advance-select", {
                                    attrs: {
                                      filterable: "",
                                      no: "settlement",
                                      "select-type":
                                        _vm.selectTypeNames.basic_data_Company,
                                      "default-value":
                                        Number(_vm.billing.accountId) === 0
                                          ? ""
                                          : Number(_vm.billing.accountId),
                                      disabled: _vm.isView,
                                      "method-params": { auto_accountId: true },
                                      cache: false,
                                      "tag-name": _vm.isZh
                                        ? "chineseName"
                                        : "englishName",
                                      "static-options": _vm.accountArray
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        _vm.billing.accountId = p.value
                                        _vm.$emit("accountIdChange")
                                      }
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_SettlementAgent")
                              }
                            },
                            [
                              _vm.isBySettlementAgent
                                ? _c("el-input", {
                                    attrs: {
                                      disabled: true,
                                      no: "settlementAgentId"
                                    },
                                    model: {
                                      value: _vm.billing.settlementAgent,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.billing,
                                          "settlementAgent",
                                          $$v
                                        )
                                      },
                                      expression: "billing.settlementAgent"
                                    }
                                  })
                                : _vm._e(),
                              !_vm.isBySettlementAgent
                                ? _c("cargo-advance-select", {
                                    attrs: {
                                      filterable: "",
                                      no: "3",
                                      "select-type":
                                        _vm.selectTypeNames.basic_data_Company,
                                      "default-value":
                                        Number(
                                          _vm.billing.settlementAgentId
                                        ) === 0
                                          ? ""
                                          : Number(
                                              _vm.billing.settlementAgentId
                                            ),
                                      disabled: _vm.isView,
                                      "method-params": { auto_accountId: true },
                                      cache: false,
                                      "tag-name": _vm.isZh
                                        ? "chineseName"
                                        : "englishName",
                                      "static-options": _vm.settlementAgentArray
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        return (_vm.billing.settlementAgentId =
                                          p.value)
                                      }
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_InvoiceHeader")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  no: "4",
                                  "select-type":
                                    _vm.selectTypeNames.static_data_Title,
                                  "allow-create": true,
                                  filterable: "",
                                  cache: false,
                                  disabled: _vm.isView,
                                  "default-value": _vm.invoiceTitleUuid,
                                  "tag-value": "uuid",
                                  "static-options": _vm.titleArray
                                },
                                on: { parentCallBack: _vm.titleChangeEvent }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("Partners.CustomerMailbox")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: true, no: "customerEmail" },
                                model: {
                                  value: _vm.billing.customerEmail,
                                  callback: function($$v) {
                                    _vm.$set(_vm.billing, "customerEmail", $$v)
                                  },
                                  expression: "billing.customerEmail"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "CargoMsg.Cargo_RegistrationAddress"
                                )
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: _vm.isView, no: "5" },
                                model: {
                                  value: _vm.billing.buyerAddress,
                                  callback: function($$v) {
                                    _vm.$set(_vm.billing, "buyerAddress", $$v)
                                  },
                                  expression: "billing.buyerAddress"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { staticClass: "inline" },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "CargoMsg.Cargo_RegistrationNumber"
                                )
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: true, no: "6" },
                                model: {
                                  value: _vm.billing.buyerTaxAccount,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.billing,
                                      "buyerTaxAccount",
                                      $$v
                                    )
                                  },
                                  expression: "billing.buyerTaxAccount"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("CargoMsg.Cargo_Tel") } },
                            [
                              _c("el-input", {
                                attrs: { disabled: _vm.isView, no: "7" },
                                model: {
                                  value: _vm.billing.buyerTelephone,
                                  callback: function($$v) {
                                    _vm.$set(_vm.billing, "buyerTelephone", $$v)
                                  },
                                  expression: "billing.buyerTelephone"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { staticClass: "inline" },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_DepositBank")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  filterable: "",
                                  no: "8",
                                  "select-type":
                                    _vm.selectTypeNames.static_data_TitleBank,
                                  "default-value": _vm.titleBankUuid,
                                  disabled: _vm.isView,
                                  cache: false,
                                  "tag-value": "uuid",
                                  "static-options": _vm.titleBankArray
                                },
                                on: { parentCallBack: _vm.getBankCusFromChild }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_AccountNumber")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: true, no: "9" },
                                model: {
                                  value: _vm.billing.buyerBankAccount,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.billing,
                                      "buyerBankAccount",
                                      $$v
                                    )
                                  },
                                  expression: "billing.buyerBankAccount"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "CargoMsg.Cargo_RevenueAndExpenditureType"
                                )
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: true,
                                  no: "10",
                                  value: _vm.billing.ar
                                    ? _vm.$t("CargoMsg.Cargo_Receivable")
                                    : _vm.$t("CargoMsg.Cargo_Dues")
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { staticClass: "inline" },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "CargoMsg.Cargo_OwnerBankOfDeposit"
                                )
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  filterable: "",
                                  no: "11",
                                  cache: false,
                                  disabled: _vm.isView,
                                  "select-type":
                                    _vm.selectTypeNames.static_data_BankAccount,
                                  "default-value":
                                    _vm.billing.bankAccountId === 0
                                      ? ""
                                      : _vm.billing.bankAccountId,
                                  "static-options": _vm.ourBankAccountArray
                                },
                                on: {
                                  parentCallBack: _vm.getOurBankAccountFromChild
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_AccountNumber")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: true, no: "12" },
                                model: {
                                  value: _vm.billing.bankAccount,
                                  callback: function($$v) {
                                    _vm.$set(_vm.billing, "bankAccount", $$v)
                                  },
                                  expression: "billing.bankAccount"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_BillDate")
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  no: "13",
                                  type: "date",
                                  clearable: false,
                                  editable: false,
                                  disabled: _vm.isView,
                                  format: "yyyy-MM-dd",
                                  "value-format": "yyyy-MM-dd"
                                },
                                on: { change: _vm.inputDateChange },
                                model: {
                                  value: _vm.billing.inputDate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.billing, "inputDate", $$v)
                                  },
                                  expression: "billing.inputDate"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_AgentBillNo")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled:
                                    (_vm.billing.state > 0 && !_vm.isView) ||
                                    _vm.isView,
                                  no: "14"
                                },
                                model: {
                                  value: _vm.billing.counterPartyBillingNo,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.billing,
                                      "counterPartyBillingNo",
                                      $$v
                                    )
                                  },
                                  expression: "billing.counterPartyBillingNo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.billing.billingType ===
                                _vm.$t("SeaExport.InternalBillInfo"),
                              expression:
                                "billing.billingType === $t('SeaExport.InternalBillInfo')"
                            }
                          ]
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("Invoice.invoice_invoiceCategory")
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    disabled: _vm.isView,
                                    no: "16",
                                    placeholder: _vm.isView
                                      ? ""
                                      : _vm.$t("CargoMsg.Cargo_PleaseSelect"),
                                    clearable: ""
                                  },
                                  on: { change: _vm.changeInvoiceMakeType },
                                  model: {
                                    value: _vm.billing.invoiceMakeType,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.billing,
                                        "invoiceMakeType",
                                        $$v
                                      )
                                    },
                                    expression: "billing.invoiceMakeType"
                                  }
                                },
                                _vm._l(_vm.invoiceMakeTypes, function(
                                  item,
                                  index
                                ) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.chineseName,
                                      value: item.code
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.billing.billingType ===
                                _vm.$t("SeaExport.InternalBillInfo"),
                              expression:
                                "billing.billingType === $t('SeaExport.InternalBillInfo')"
                            }
                          ]
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_InvoiceType")
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    disabled: _vm.isView,
                                    no: "15",
                                    placeholder: _vm.isView
                                      ? ""
                                      : _vm.$t("CargoMsg.Cargo_PleaseSelect"),
                                    clearable: ""
                                  },
                                  model: {
                                    value: _vm.billing.invoiceType,
                                    callback: function($$v) {
                                      _vm.$set(_vm.billing, "invoiceType", $$v)
                                    },
                                    expression: "billing.invoiceType"
                                  }
                                },
                                _vm._l(_vm.invoiceTypes, function(item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.chineseName,
                                      value: item.code
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.billing.billingType === "国内账单",
                              expression: "billing.billingType === '国内账单'"
                            }
                          ]
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "Billing.billingJob_settlementType"
                                )
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { disabled: _vm.isView, no: "17" },
                                  model: {
                                    value: _vm.billing.settlementType,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.billing,
                                        "settlementType",
                                        $$v
                                      )
                                    },
                                    expression: "billing.settlementType"
                                  }
                                },
                                [
                                  _vm.billing.settlementType === 0
                                    ? _c("el-option", {
                                        key: -1,
                                        attrs: { label: " ", value: 0 }
                                      })
                                    : _vm._e(),
                                  _vm._l(_vm.SETTLEMENT_TYPE_STATES, function(
                                    item,
                                    index
                                  ) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: _vm.$store.getters.isZh
                                          ? item.chineseName
                                          : item.englishName,
                                        value: item.code
                                      }
                                    })
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "el-col",
                { staticStyle: { flex: "1" }, attrs: { span: 16 } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "section",
                      staticStyle: { flex: "1", height: "100%" }
                    },
                    [
                      _c(
                        "div",
                        [
                          _c(
                            "el-col",
                            {
                              staticStyle: { width: "450px" },
                              attrs: { span: 10 }
                            },
                            [
                              _c(
                                "el-col",
                                [
                                  _c("el-col", { attrs: { span: 8 } }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "CargoMsg.Cargo_OriginalCurrency2"
                                        )
                                      )
                                    )
                                  ]),
                                  _c("el-col", { attrs: { span: 8 } }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("CargoMsg.Cargo_Amount"))
                                    )
                                  ]),
                                  _c("el-col", { attrs: { span: 8 } }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_ExchangeRate2")
                                      )
                                    )
                                  ])
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 8 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { "label-width": "0" } },
                                        [
                                          _c("el-input", {
                                            staticStyle: { width: "100px" },
                                            attrs: { no: "17", disabled: true },
                                            model: {
                                              value:
                                                _vm.billing.sourceCurrency1,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.billing,
                                                  "sourceCurrency1",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "billing.sourceCurrency1"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 8 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { "label-width": "0" } },
                                        [
                                          _c("el-input-number", {
                                            attrs: {
                                              no: "18",
                                              "controls-position": "right",
                                              min: -999999999999,
                                              max: 999999999999,
                                              precision: 2,
                                              disabled: true
                                            },
                                            model: {
                                              value: _vm.billing.amount1,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.billing,
                                                  "amount1",
                                                  $$v
                                                )
                                              },
                                              expression: "billing.amount1"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 8 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { "label-width": "0" } },
                                        [
                                          _c("num-input", {
                                            attrs: {
                                              no: "19",
                                              min: 0,
                                              max: 999999999,
                                              precision: 8,
                                              "truncated-precision":
                                                _vm.sourceRate1Precision,
                                              disabled:
                                                _vm.billingFormParams
                                                  .sourceRate1Enable
                                            },
                                            on: { change: _vm.calculateAmount },
                                            model: {
                                              value: _vm.billing.sourceRate1,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.billing,
                                                  "sourceRate1",
                                                  $$v
                                                )
                                              },
                                              expression: "billing.sourceRate1"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              !_vm.splitBillButton
                                ? _c(
                                    "el-col",
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 8 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            { attrs: { "label-width": "0" } },
                                            [
                                              _c("el-input", {
                                                staticStyle: { width: "100px" },
                                                attrs: {
                                                  no: "20",
                                                  disabled: true
                                                },
                                                model: {
                                                  value:
                                                    _vm.billing.sourceCurrency2,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.billing,
                                                      "sourceCurrency2",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "billing.sourceCurrency2"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 8 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            { attrs: { "label-width": "0" } },
                                            [
                                              _c("el-input-number", {
                                                attrs: {
                                                  no: "21",
                                                  "controls-position": "right",
                                                  min: -999999999999,
                                                  max: 999999999999,
                                                  precision: 2,
                                                  disabled: true
                                                },
                                                model: {
                                                  value: _vm.billing.amount2,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.billing,
                                                      "amount2",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "billing.amount2"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 8 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            { attrs: { "label-width": "0" } },
                                            [
                                              _c("num-input", {
                                                attrs: {
                                                  no: "22",
                                                  min: 0,
                                                  max: 999999999,
                                                  precision: 8,
                                                  "truncated-precision":
                                                    _vm.sourceRate2Precision,
                                                  disabled:
                                                    _vm.billingFormParams
                                                      .sourceRate2Enable
                                                },
                                                on: {
                                                  change: _vm.calculateAmount
                                                },
                                                model: {
                                                  value:
                                                    _vm.billing.sourceRate2,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.billing,
                                                      "sourceRate2",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "billing.sourceRate2"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              !_vm.splitBillButton
                                ? _c(
                                    "el-col",
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 8 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            { attrs: { "label-width": "0" } },
                                            [
                                              _c("el-input", {
                                                staticStyle: { width: "100px" },
                                                attrs: {
                                                  no: "23",
                                                  disabled: true
                                                },
                                                model: {
                                                  value:
                                                    _vm.billing.sourceCurrency3,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.billing,
                                                      "sourceCurrency3",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "billing.sourceCurrency3"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 8 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            { attrs: { "label-width": "0" } },
                                            [
                                              _c("el-input-number", {
                                                attrs: {
                                                  no: "24",
                                                  "controls-position": "right",
                                                  min: -999999999999,
                                                  max: 999999999999,
                                                  precision: 2,
                                                  disabled: true
                                                },
                                                model: {
                                                  value: _vm.billing.amount3,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.billing,
                                                      "amount3",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "billing.amount3"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 8 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            { attrs: { "label-width": "0" } },
                                            [
                                              _c("num-input", {
                                                attrs: {
                                                  no: "25",
                                                  min: 0,
                                                  max: 999999999,
                                                  precision: 8,
                                                  "truncated-precision":
                                                    _vm.sourceRate3Precision,
                                                  disabled:
                                                    _vm.billingFormParams
                                                      .sourceRate3Enable
                                                },
                                                on: {
                                                  change: _vm.calculateAmount
                                                },
                                                model: {
                                                  value:
                                                    _vm.billing.sourceRate3,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.billing,
                                                      "sourceRate3",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "billing.sourceRate3"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  !_vm.billing.uuid &&
                                  _vm.customerDetail.currencyRequirements === 3
                                    ? _c(
                                        "el-checkbox",
                                        {
                                          staticStyle: { display: "block" },
                                          attrs: { no: "splitBill" },
                                          on: { change: _vm.splitBillChange },
                                          model: {
                                            value: _vm.splitBillButton,
                                            callback: function($$v) {
                                              _vm.splitBillButton = $$v
                                            },
                                            expression: "splitBillButton"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("Message.SplitBill")
                                            ) + " "
                                          )
                                        ]
                                      )
                                    : _c("div", {
                                        staticStyle: {
                                          "padding-bottom": "15px"
                                        }
                                      })
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "CargoMsg.Cargo_BillingCurrency"
                                        )
                                      }
                                    },
                                    [
                                      _c("cargo-advance-select", {
                                        attrs: {
                                          filterable: "",
                                          no: "26",
                                          "select-type":
                                            _vm.selectTypeNames
                                              .basic_data_Currency,
                                          "default-value": _vm.billing.currency,
                                          disabled:
                                            _vm.isView || _vm.splitBillButton,
                                          clearable: false
                                        },
                                        on: {
                                          parentCallBack:
                                            _vm.currencyChangeEvent
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "Billing.billingForm_taxAmount"
                                        )
                                      }
                                    },
                                    [
                                      _c("el-input-number", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          no: "27",
                                          "controls-position": "right",
                                          min: -999999999999,
                                          max: 999999999999,
                                          precision: 2,
                                          disabled: true
                                        },
                                        model: {
                                          value: _vm.billing.amount,
                                          callback: function($$v) {
                                            _vm.$set(_vm.billing, "amount", $$v)
                                          },
                                          expression: "billing.amount"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "Billing.billingForm_taxFreeAmount"
                                        )
                                      }
                                    },
                                    [
                                      _c("el-input-number", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          no: "28",
                                          "controls-position": "right",
                                          min: -999999999999,
                                          max: 999999999999,
                                          precision: 2,
                                          disabled: true
                                        },
                                        model: {
                                          value: _vm.billing.taxFreeAmount,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.billing,
                                              "taxFreeAmount",
                                              $$v
                                            )
                                          },
                                          expression: "billing.taxFreeAmount"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("el-col", {
                                staticStyle: { "padding-bottom": "14px" }
                              }),
                              _c(
                                "el-col",
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "CargoMsg.Cargo_CurrencyRequirements"
                                        )
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "100px" },
                                        attrs: { no: "29", disabled: true },
                                        model: {
                                          value: _vm.currencyRequirement,
                                          callback: function($$v) {
                                            _vm.currencyRequirement = $$v
                                          },
                                          expression: "currencyRequirement"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            [
                              _c(
                                "el-form-item",
                                { attrs: { "label-width": "0" } },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("CargoMsg.Cargo_Remarks"))
                                    )
                                  ]),
                                  _c("el-input", {
                                    attrs: {
                                      no: "30",
                                      type: "textarea",
                                      rows: 6,
                                      disabled: _vm.isView
                                    },
                                    model: {
                                      value: _vm.billing.remark,
                                      callback: function($$v) {
                                        _vm.$set(_vm.billing, "remark", $$v)
                                      },
                                      expression: "billing.remark"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "CargoMsg.Cargo_AccountContacts"
                                        ),
                                        "label-width": "105px;"
                                      }
                                    },
                                    [
                                      _c("cargo-advance-select", {
                                        staticStyle: { width: "200px" },
                                        attrs: {
                                          no: "31",
                                          "select-type":
                                            _vm.selectTypeNames
                                              .static_data_Contact,
                                          "allow-create": true,
                                          filterable: "",
                                          cache: false,
                                          clearable: "",
                                          disabled: _vm.isView,
                                          "default-value":
                                            _vm.billing.accountContacts,
                                          "static-options":
                                            _vm.accountContactsArray
                                        },
                                        on: {
                                          parentCallBack:
                                            _vm.accountContactChangeEvent
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "CargoMsg.Cargo_AccountContactsTel"
                                        )
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          disabled: _vm.isView,
                                          no: "32"
                                        },
                                        model: {
                                          value: _vm.billing.accountContactsTel,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.billing,
                                              "accountContactsTel",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "billing.accountContactsTel"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "CargoMsg.Cargo_AccountAddr"
                                        )
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          disabled: _vm.isView,
                                          no: "33"
                                        },
                                        model: {
                                          value: _vm.billing.accountAddr,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.billing,
                                              "accountAddr",
                                              $$v
                                            )
                                          },
                                          expression: "billing.accountAddr"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            [
                              _c(
                                "el-form-item",
                                { attrs: { "label-width": "0" } },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "CargoMsg.Cargo_InvoicingRequirements"
                                        )
                                      )
                                    )
                                  ]),
                                  _c("el-input", {
                                    attrs: {
                                      no: "34",
                                      type: "textarea",
                                      rows: 6,
                                      disabled: _vm.isView
                                    },
                                    model: {
                                      value: _vm.billing.invoiceDemand,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.billing,
                                          "invoiceDemand",
                                          $$v
                                        )
                                      },
                                      expression: "billing.invoiceDemand"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }